module.exports = __webpack_public_path__ + "img/img5.88b96934.png";